import { Users, Coins } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";
import type { TableSummary } from "@/features/poker/hooks/useTableLobby";

interface TableCardProps {
  table: TableSummary;
  onJoin: () => void;
  joining?: boolean;
}

export const TableCard = ({ table, onJoin, joining }: TableCardProps) => {
  const { t } = useTranslation();
  const isLive = table.phase !== "idle" && table.players > 0;

  return (
    <div className="glass hover-lift p-4">
      <div className="flex items-center justify-between">
        <div className="flex-1">
          <div className="flex items-center gap-2 mb-1">
            <span className="font-mono font-bold text-secondary">
              {table.sb}/{table.bb}
            </span>
            {isLive && (
              <div className="flex items-center gap-1">
                <div className="w-1.5 h-1.5 bg-green-500 rounded-full animate-pulse" />
                <span className="text-[10px] text-green-500 font-medium">
                  {t("lobby_live")}
                </span>
              </div>
            )}
          </div>
          <div className="flex items-center gap-3 text-[11px] text-muted-foreground">
            <span className="flex items-center gap-1">
              <Users className="w-3 h-3" />
              {table.players}/{table.maxPlayers}
            </span>
            {table.gameMode === "cash" ? (
              <span className="flex items-center gap-1">
                <Coins className="w-3 h-3" />
                {table.minBuyIn.toLocaleString()}–
                {table.maxBuyIn.toLocaleString()}
              </span>
            ) : (
              <span className="flex items-center gap-1">
                <Coins className="w-3 h-3" />
                {table.startingStack.toLocaleString()} {t("poker_chips")}
              </span>
            )}
          </div>
        </div>
        <Button
          size="sm"
          variant="outline"
          onClick={onJoin}
          disabled={joining || table.players >= table.maxPlayers}
          className="shrink-0"
        >
          {table.players >= table.maxPlayers
            ? t("lobby_full")
            : t("lobby_join")}
        </Button>
      </div>
    </div>
  );
};
